// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { config } from '@iheartjane/config';
import { StreamChat } from 'stream-chat';
import {
  Avatar,
  Channel,
  Chat,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from 'stream-chat-react';

import { useConversationContext } from '../providers/conversationProvider';
import { CustomMessage } from './customMessage';

const StreamOverrides = styled.div({
  '.str-chat.messaging': {
    position: 'absolute',
    width: '100vw',
    top: 'env(safe-area-inset-top)',
    bottom: 'env(safe-area-inset-bottom)',
    height: '100%',
    '&, .str-chat__main-panel': {
      padding: 0,
      margin: 0,
    },
    '.str-chat__reverse-infinite-scroll': {
      paddingTop: 0,
    },
  },
});

export const Conversation = () => {
  const chatClient = StreamChat.getInstance(config.streamChatApiToken);
  const { channel, store } = useConversationContext();
  return (
    <Chat client={chatClient}>
      <StreamOverrides>
        <Channel channel={channel} Message={CustomMessage}>
          <Window>
            <div
              className="str-chat__header-livestream"
              style={{ justifyContent: 'center', flexWrap: 'nowrap' }}
            >
              <Avatar image={store.photo} name={store.name} />
              <p className="str-chat__header-livestream-left--title">
                {store.name}
              </p>
            </div>
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </StreamOverrides>
    </Chat>
  );
};
